import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import '../streamer-cards/StreamerCards.css'
import { Grid, Button, Avatar } from '@material-ui/core'
import { FiberManualRecord, Done } from '@material-ui/icons'
import { addDefaultSrc } from '../../utils/imgUtil'
import { useTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import GiveGiftDialog from '../streamer-cards/GiveGiftDialog'
import StreamCard from '../cabinet/StreamCard'
import defaultImage from '../../assets/images/TestBanner.png'

import defaultAvatar from '../../assets/images/Default.jpg'

const styles = theme => ({
  button: {
    float: 'left',
    marginLeft: 10,
  },
  buttonText: {
    fontSize: 8,
    color: 'white',
    textAlign: 'center',
    alignSelf: 'center',
    flex: 1,
    justifyContent: 'center',
    margin: 0
  },
  mainContainer: {
    paddingTop: 64
  },
  containerHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },
  aboutStreamerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  rowDirection: {
    display: 'flex',
    flexDirection: 'row',
    height: 45,
    paddingTop: 8
  },
  streamerName: {
    fontSize: 25,
    textAlign: 'left',
    color: 'dark',
    margin: 0,
    marginLeft: 10,
    marginTop: 5
  },
  aboutSpeaker: {
    color: 'black',
    fontSize: 12,
    fontWeight: '600'
  },
  checkSubscribe: {
    fontSize: 16,
    fontWeight: '500',
    color: '#404040'
  },
  avatar: {
    margin: theme.spacing.unit,
    width: 200,
    height: 200
  },
  navigationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between'
  },
  navigationWrapperPanel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'

  },
  streamsWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  buttonNavigation: {
    marginRight: 10,
    marginTop: 15,
    marginLeft: 10,
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  nameBlockWrapper: {
    marginLeft: 30
  },
  sectionTitle: {
    width: 200
  },
  sectionContent: {
    flex: 1
  },
  fieldText: {
    textAlign: 'left'
  },
})

const StreamerCard = ({
  streamers,
  classes,
  personId,
  subscribers,
  addSubscriber,
  myGifts,
  giveGift,
  fetchMyGifts,
  fetchSubscribers,
  isLoadingSubscribers,
  isLoadingGifts
}) => {
  let { id } = useParams()
  id = parseInt(id)
  const streamer = streamers.filter(item => (item.id === id))[0]
  const { t } = useTranslation()
  useEffect(() => {
    if (subscribers === undefined && !isLoadingSubscribers && personId) {
      fetchSubscribers()
    }

    if (myGifts === undefined && !isLoadingGifts && personId) {
      fetchMyGifts()
    }
  })
  const aboutStreamerRef = React.createRef()
  const scheduleRef = React.createRef()
  const reviewsRef = React.createRef()
  const forWhomRef = React.createRef()
  const [giveGiftDialogVisible, setGiftDialogVisible] = useState(false)
  if (!streamer) return null

  const handleScrollToSection = (refToScroll) => {
    window.scrollTo({
      top: refToScroll.current.offsetTop,
      behavior: 'smooth'
    })
  }
  // render subscribe button or is subscribe flag
  const renderSubscribeButton = () => {
    const isSubscribe = (subscribers.filter(item => (item.id === streamer.id)).length === 1)
    if (!isSubscribe) {
      return (
        <Button
          size="small"
          className={classes.button}
          variant='contained'
          color='primary'
          onClick={() => { addSubscriber(streamer) }}
        >
          {t('TopBar:subscribe')}
        </Button>
      )
    }
    return (
      <div className={classes.aboutStreamerContainer}>
        <Done className={classes.checkSubscribe} />
        <p className={classes.checkSubscribe} >
          {t('you subscribe')}
        </p>
      </div>
    )
  }
  // render top buttons
  const renderButtons = () => {
    if (!personId || subscribers === undefined) {
      return null
    }
    return (
      <div className={classes.rowDirection}>
        {renderSubscribeButton()}
        <Button
          size="small"
          className={classes.button}
          variant='contained'
          color='primary'
          onClick={() => setGiftDialogVisible(true)}
        >
          {t('TopBar:gift')}
        </Button>
      </div>
    )
  }

  const avatar = (streamer.avatarBytes) ? (`data:image/jpeg;base64,${streamer.avatarBytes}`) : null

  return (
    <div className={classes.mainContainer}>
      <div className={classes.containerHeader}>
        <div className={classes.navigationWrapper}>
          <Avatar src={(avatar || defaultAvatar)} className={classes.avatar} />
          <div className={classes.nameBlockWrapper}>
            <p className={classes.streamerName}>
              {streamer.name}
            </p>
            <div className={classes.navigationWrapperPanel}>
              <p
                className={classes.buttonNavigation}
                onClick={() => (handleScrollToSection(aboutStreamerRef))}
              >
                {t('TopBar:about speaker')}
              </p>
              <p
                className={classes.buttonNavigation}
                onClick={() => (handleScrollToSection(scheduleRef))}
              >
                {t('TopBar:schedule')}
              </p>
              <p
                className={classes.buttonNavigation}
                onClick={() => (handleScrollToSection(forWhomRef))}
              >
                {t('TopBar:for whom')}
              </p>
              <p
                className={classes.buttonNavigation}
                onClick={() => (handleScrollToSection(reviewsRef))}
              >
                {t('TopBar:reviews')}
              </p>
            </div>
          </div>
        </div>
        {renderButtons()}
      </div>
      <div className={classes.navigationWrapper} ref={aboutStreamerRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:about speaker')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {streamer.description}
          </p>
        </div>
      </div>
      <div className={classes.navigationWrapper} ref={scheduleRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:schedule')}</p>
        </div>
        {
          (!streamer.activeStreams || streamer.activeStreams.length === 0) ? (
            <div className={classes.sectionContent}>
              <p className={classes.fieldText}>
                {t('TopBar:empty schedule')}
              </p>
            </div>
          ) : (
            <div className={classes.streamsWrapper}>
              {
                streamer.activeStreams.map((stream) => (
                  <StreamCard key={stream.id}
                    image={(stream.avatarBytes) ? (`data:image/jpeg;base64,${stream.avatarBytes}`) : defaultImage}
                    title={stream.title}
                    descr={stream.description}
                    price={'$100 USD'}
                    startDate={stream.startDate}
                    actionLabel={t('Cabinet:watch stream')}
                  />
                ))
              }
            </div>

          )
        }
      </div>
      <div className={classes.navigationWrapper} ref={forWhomRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:for whom')}</p>
        </div>
        <div className={classes.sectionContent}>
          <p className={classes.fieldText}>
            {'Провожу обучение для:'}
          </p>
          <p className={classes.fieldText}>
            {'- маркетологов'}
          </p>
          <p className={classes.fieldText}>
            {'- SMM маркетологов'}
          </p>
          <p className={classes.fieldText}>
            {'- владельцы бизнеса, которые хотят увеличить доход из интернета'}
          </p>
        </div>
      </div>
      <div className={classes.navigationWrapper} ref={reviewsRef}>
        <div className={classes.sectionTitle}>
          <p>{t('TopBar:reviews')}</p>
        </div>
        <div className={classes.sectionContent}>
          {/* <p className={classes.fieldText}>
            {streamer.description}
          </p> */}
        </div>
      </div>
      <GiveGiftDialog
        open={giveGiftDialogVisible}
        onClose={() => setGiftDialogVisible(false)}
        myGifts={myGifts}
        giveGift={(giftId) => giveGift(streamer.id, giftId)}
      />
    </div>
  )
}

export default withStyles(styles)(StreamerCard)
